import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=2218a4c2&scoped=true&"
import script from "./Playlist.vue?vue&type=script&lang=js&"
export * from "./Playlist.vue?vue&type=script&lang=js&"
import style0 from "./Playlist.vue?vue&type=style&index=0&id=2218a4c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2218a4c2",
  null
  
)

export default component.exports